import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import Projeto from '@src/Pages/Private/Cliente/Admin/TiposFormasContribuicao/IR/Create/Projeto';
import Fundo from '@src/Pages/Private/Cliente/Admin/TiposFormasContribuicao/IR/Create/Fundo';
import Documento from '@src/Pages/Private/Cliente/Admin/TiposFormasContribuicao/IR/Create/Documento';



const Create: React.FC = () => {

  const [status, setStatus] = useState('');

  const [openProjeto, setOpenProjeto] = useState(false);
  const [openFundo, setOpenFundo] = useState(false);
  const [openDocumento, setOpenDocumento] = useState(false);

  useEffect(() => {
    window.document.title = 'CRM - Formas contribuições';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Fundo' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Fundo'), setOpenFundo(true), setOpenProjeto(false), setOpenDocumento(false))}
          >
            Fundo
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Projeto' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Projeto'), setOpenProjeto(true), setOpenFundo(false), setOpenDocumento(false))}
          >
            Projeto
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Documentos' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Documentos'), setOpenDocumento(true), setOpenFundo(false), setOpenProjeto(false))}
          >
            Documentos
          </ButtonComponent>
        </Grid>

        <InvisibleContent visible={openProjeto === true}>
          <Projeto />
        </InvisibleContent>

        <InvisibleContent visible={openFundo === true}>
          <Fundo />
        </InvisibleContent>

        <InvisibleContent visible={openDocumento === true}>
          <Documento />
        </InvisibleContent>


      </Grid>

    </Grid>
  );
};

export default Create;
